import { selectUrlState } from 'containers/ResolutionCenter/List/selectors'

import { PLAN_TYPES } from '../App/constants'
import { selectActualLicenses } from '../App/selectors'

import { URL_STATE } from './List/constants'
import {
  EXCLUDING_THEMIS_SPAM_SAFE_OPTION,
  GENERAL_FILTER_OPTIONS,
  GENERAL_FILTER_STARTER_OPTIONS,
} from './constants'

const selectData = (state) => state.resolutioncenter.self.data
const selectLoader = (state) => state.resolutioncenter.self.loader
const selectError = (state) => state.resolutioncenter.self.error
const selectIsDataLoaded = (state) => state.resolutioncenter.self.isDataLoaded

const selectGeneralFilterOptions = (state) => {
  if (selectActualLicenses(state).plan === PLAN_TYPES.STARTER) return GENERAL_FILTER_STARTER_OPTIONS
  if (selectUrlState(state) === URL_STATE.SCANBACK) {
    return GENERAL_FILTER_OPTIONS.concat(EXCLUDING_THEMIS_SPAM_SAFE_OPTION)
  }
  return GENERAL_FILTER_OPTIONS
}

export { selectData, selectLoader, selectError, selectIsDataLoaded, selectGeneralFilterOptions }
